import { useEffect, useState } from "react";
import { useApi } from "../../hooks/use-api";
import { apiLearingPath } from "../../utils/api-routes";
import { useNavigate } from "react-router-dom";
import { useSingleton } from "../../hooks/use-singleton";
import { ROUTE_DASHBOARD } from "../../route/studentRoute";
import { ROUTE_DASHBOARD as TnpscRoute } from "../../route/tnpscRoute";
import { ROUTE_DASHBOARD as NeetJ2ERoute } from "../../route/neetJteRoute";
import { ROUTE_DASHBOARD as BankinRoutes } from "../../route/bankingRoute";
import {
  ROUTE_STUDENT_MANAGEMENT,
  ROUTE_DASHBOARD as ROUTE_USER_DASHBOARD,
} from "../../route";
import { ROUTE_DASHBOARD as teacherRouter } from "../../route/teacherRoute";
import { ROUTE_DASHBOARD as communicateDasboard } from "../../route/communicative";
import { COOKIE_ACCESS_MAIL } from "../../utils/storage-constants";
import { useAuth } from "../../hooks/use-auth";

const useHandler = () => {
  const { get } = useApi();
  const { persistSession } = useAuth();
  const { role, board, examType } = useSingleton();
  const navigate = useNavigate();
  const [pathRes, setPathRes] = useState();
  const email = localStorage.getItem(COOKIE_ACCESS_MAIL);
  const learningPathSuccess = async () => {
    try {
      const res = await get(apiLearingPath(email));
      if (res) {
        setPathRes(res?.data);
        persistSession(res?.data);
      }
    } catch (e) {
      console.log("ERROR COMES FROM LEARNING PATH SUCCESS API", e);
    }
  };

  useEffect(() => {
    learningPathSuccess();
  }, []);

  const goToDashboard = () => {
    if (role === "student") {
      navigate(ROUTE_USER_DASHBOARD, { replace: true });
    } else if (role === "aspirant" && examType?.startsWith("TNPSC")) {
      navigate(TnpscRoute, { replace: true });
    } else if (role === "aspirant" && examType?.startsWith("UPSC")) {
      navigate(ROUTE_DASHBOARD, { replace: true });
    } else if (role === "aspirant" && (board === "NEET" || board === "JEE")) {
      navigate(NeetJ2ERoute, { replace: true });
    } else if (role === "admin") {
      navigate(ROUTE_STUDENT_MANAGEMENT, { replace: true });
    } else if (role === "guest" && examType?.startsWith("TNPSC")) {
      navigate(TnpscRoute, { replace: true });
    } else if (role === "guest" && examType?.startsWith("UPSC")) {
      navigate(ROUTE_DASHBOARD, { replace: true });
    } else if (
      role === "guest" &&
      (examType?.startsWith("NEET") || examType?.startsWith("JEE"))
    ) {
      navigate(NeetJ2ERoute, { replace: true });
    } else if (
      role === "guest" &&
      (examType?.startsWith("CBSE") || examType?.startsWith("TN_STATE_BOARD"))
    ) {
      navigate(ROUTE_USER_DASHBOARD, { replace: true });
    } else if (
      role === "aspirant" &&
      (board === "Banking" || examType?.startsWith("Banking"))
    ) {
      navigate(BankinRoutes, { replace: true });
    } else if (role === "teacher") {
      navigate(teacherRouter, { replace: true });
    } else if (
      role === "ce_user" &&
      examType?.startsWith("Communicative English")
    ) {
      navigate(communicateDasboard, { replace: true });
    } else if (
      role === "guest" &&
      examType?.startsWith("Communicative English")
    ) {
      navigate(communicateDasboard, { replace: true });
    }
  };

  return {
    pathRes,
    navigate,
    goToDashboard,
  };
};

export default useHandler;
